module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "request-subjects__user text-dark"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v("\n      " + _vm._s(_vm.sumOfHours) + "\n    ")])]), _vm._v(" "), _c('tbody', [(_vm.userSubjects.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Ingen fag ønsket")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userSubjects), function(subject) {
    return _c('tr', {
      key: subject.id
    }, [_c('td', {
      staticClass: "td-delete"
    }, [(!_vm.loadingSubjects[subject.id]) ? _c('div', {
      staticClass: "icon__bg-circle icon-bin",
      on: {
        "click": function($event) {
          return _vm.$emit('removeSubject', subject.id)
        }
      }
    }) : _c('div', {
      staticClass: "do-spinner do-spinner-small"
    })]), _vm._v(" "), _c('td', {
      staticClass: "td-subjects"
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          onShow: function () { return subject.vRequestedBy.length > 0; }
        }),
        expression: "{\n          arrow: true,\n          onShow: () => subject.vRequestedBy.length > 0\n        }"
      }],
      staticClass: "subjects_subject subjects_subject__simple",
      class: {
        'subjects_subject--has-user': subject.vRequestedBy.length > 0
      },
      style: ([{
        'border-left-color': subject.color
      }, {
        'background-color': subject.color
      }]),
      attrs: {
        "content": !subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'
      }
    }, [_vm._v("\n          " + _vm._s(subject.name) + "\n        ")])]), _vm._v(" "), _c('td', {
      staticClass: "td-calendars"
    }, [_vm._v(_vm._s(subject.vKlass))]), _vm._v(" "), _c('td', {
      staticClass: "number"
    }, [_vm._v("\n        " + _vm._s(subject.hours) + "\n      ")])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "request-subjects__user__header"
  }, [_c('h2', {
    staticClass: "pad-1"
  }, [_vm._v("Dine ønsker")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ce3ee74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/RequestSubjectsUser.vue
// module id = 1478
// module chunks = 1